<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3 g-2 align-items-end">
                        <div class="col-auto">
                            <a class="btn btn-option" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <select class="form-control" v-model="params.project_id" name="project_id" @change="onProjectChange">
                                <option value="">Select Project</option>
                                <option v-for="each in projects" :key="each.id" :value="each.id" v-text="each.name"></option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <div class="autocomplete-input">
                                <input type="text"
                                       class="form-control"
                                       placeholder="Search Shareholder"
                                       v-model="shareholderKeyword"
                                       :disabled="!params.project_id"
                                       autocomplete="off"
                                       @input="onShareholderInput"
                                       @focus="searchShareholders">
                                <i v-if="params.shareholder_id"
                                   class="input-loader cursor-pointer bx bx-x fs-4"
                                   style="top: 0.1rem"
                                   @mousedown.prevent="clearShareholder"></i>
                                <div class="input-result" v-if="shareholderOptions.length > 0">
                                    <div class="each-box" v-for="member in shareholderOptions" :key="member.id" @click="selectShareholder(member)">
                                        {{ member.shareholder_name || member.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-inverse-primary w-100" @click="fetchReport">Search</button>
                        </div>
                    </div>

                    <div class="table-responsive mb-3" v-if="reportData.shareholder_name">
                        <table class="table table-bordered mb-0">
                            <tr>
                                <th colspan="2" class="text-center">Deposit Details by Shareholder</th>
                                <td rowspan="8" class="text-center" style="width: 180px">
                                    <img :src="reportData.image_path" alt="" style="max-width: 160px; max-height: 140px">
                                </td>
                            </tr>
                            <tr>
                                <th style="width: 180px">Project Name</th>
                                <td>{{ reportData.project_name }}</td>
                            </tr>
                            <tr>
                                <th>Member Name</th>
                                <td>{{ reportData.shareholder_name }}</td>
                            </tr>
                            <tr>
                                <th>Member ID</th>
                                <td>{{ reportData.id_number }}</td>
                            </tr>
                            <tr>
                                <th>Total Share</th>
                                <td>{{ reportData.total_share }}</td>
                            </tr>
                            <tr>
                                <th>Mobile No</th>
                                <td>{{ reportData.mobile_number }}</td>
                            </tr>
                            <tr>
                                <th>Total Deposit</th>
                                <td class="text-end">{{ reportData.total_deposit }}</td>
                            </tr>
                            <tr>
                                <th>Already Paid</th>
                                <td class="text-end">{{ reportData.already_paid }}</td>
                            </tr>
                            <tr>
                                <th>Balance</th>
                                <td class="text-end" colspan="2">{{ reportData.balance }}</td>
                            </tr>
                            <tr>
                                <th>Date Range</th>
                                <td colspan="2">{{ reportData.date_range }}</td>
                            </tr>
                        </table>
                    </div>

                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Date</th>
                                <th>Particulars</th>
                                <th>Payment Method</th>
                                <th>Cash Received By</th>
                                <th class="text-end">Deposit</th>
                                <th>Remarks</th>
                            </tr>
                            </thead>
                            <template v-if="!loading && reportData['data']?.length > 0">
                                <tbody>
                                <tr v-for="(data,index) in reportData['data']" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ data.date }}</td>
                                    <td>{{ data.category_name }}</td>
                                    <td>{{ data.payment_method }}</td>
                                    <td>{{ data.cash_received_by }}</td>
                                    <td class="text-end">{{ data.amount }}</td>
                                    <td>{{ data.remarks }}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th class="text-end" colspan="5">Total</th>
                                    <th class="text-end">{{ reportData.total.total_deposit }}</th>
                                    <th></th>
                                </tr>
                                </tfoot>
                            </template>
                            <template v-if="!loading && (!reportData['data'] || reportData['data'].length === 0)">
                                <tr class="text-center">
                                    <td colspan="100" class="fw-bold fs-6 text-height">
                                        No Data Found
                                        <br>
                                        Please search by project and shareholder.
                                    </td>
                                </tr>
                            </template>
                            <tbody v-if="loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Breadcrumb from "../Common/Breadcrumb.vue";
import Loader from "../Common/Loader.vue";

export default {
    components: {Loader, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Deposit Details by Shareholder'],
            reportData: {},
            projects: [],
            shareholderKeyword: '',
            shareholderOptions: [],
            params: {
                project_id: '',
                shareholder_id: ''
            },
            loading: false,
            exportLoading: false,
        }
    },
    methods: {
        downloadFile: function () {
            if (!this.params.project_id || !this.params.shareholder_id) {
                return;
            }
            PrintService.print('/report/deposit-details-by-shareholder/print?project_id=' + this.params.project_id + '&shareholder_id=' + this.params.shareholder_id);
        },
        onProjectChange() {
            this.params.shareholder_id = '';
            this.shareholderKeyword = '';
            this.shareholderOptions = [];
            this.reportData = {};
        },
        onShareholderInput() {
            this.params.shareholder_id = '';
            this.searchShareholders();
        },
        searchShareholders() {
            if (!this.params.project_id) {
                this.shareholderOptions = [];
                return;
            }
            ApiService.POST(ApiRoutes.ShareHolder + '/search', {
                project_id: this.params.project_id,
                keyword: this.shareholderKeyword
            }, (res) => {
                if (parseInt(res.status) === 200) {
                    this.shareholderOptions = res.data;
                }
            });
        },
        selectShareholder(member) {
            this.params.shareholder_id = member.id;
            this.shareholderKeyword = member.shareholder_name || member.name;
            this.shareholderOptions = [];
        },
        clearShareholder() {
            this.params.shareholder_id = '';
            this.shareholderKeyword = '';
            this.shareholderOptions = [];
        },
        fetchProject() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        fetchReport() {
            this.loading = true;
            ApiService.POST(ApiRoutes.Report + '/deposit-details-by-shareholder', this.params, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.reportData = res;
                }
            });
        }
    },
    created() {
        this.fetchProject();
    }
}
</script>
